import { ColumnHeader, IPageRange, PageTurnOptions, PagingHelper, Table } from '@aon/aon-tws-common-ui';
import React, { useState } from 'react';
import { cloneDeep as _cloneDeep } from 'lodash';
import styled from 'styled-components';
import { AudienceSourceType, IAudience, IColumn } from '../../../models';
import { defaultAudienceColumns } from '../../../store/AudienceListStore';
import { ColumnHelper } from '../../../utilities';
import { AudienceMode } from '../AudienceMode';
import { AudienceRow } from './AudienceRow';
import { AudienceTableUtilities } from './AudienceTableUtilities';

export type AudienceTableProps = {
	surveyId: number;
	audiences: IAudience[];
	audienceDeleteInProgress: boolean | undefined;
	audienceSourceType: AudienceSourceType | undefined;
	mode: AudienceMode;
	columns?: IColumn[];
};

const AudienceListTable = styled.div`
	.tws-dropdown-menuitem {
		text-align: left;
	}
`;

export const AudienceTable = (props: AudienceTableProps) => {
	const [pageRange, setPageRange] = useState<IPageRange>({ offset: 0, limit: 25, total: props.audiences.length });
	const [filteredAudiences, setFilteredAudiences] = useState(filterAudiences(''));
	const [pagedAudiences, setPagedAudiences] = useState(getPagedAudiences(filteredAudiences, pageRange));
	const [searchText, setSearchText] = useState('');
	const [columns, setColumns] = useState(props.columns ? props.columns : defaultAudienceColumns);

	return (
		<>
			<AudienceTableUtilities
				surveyId={props.surveyId}
				onSearch={handleSearch}
				pageRange={pageRange}
				columns={columns}
				onColumnChange={handleColumnChange}
				onPageChange={handlePageChange}
				resultsCount={getFilteredCount()}
			/>
			<AudienceListTable>
				<Table responsive={true} lastalign='right'>
					<ColumnHeader columns={ColumnHelper.GetColumnHeaders(columns)} />

					<tbody>
						{pagedAudiences.map((audience: IAudience, index: number) => (
							<AudienceRow
								key={index}
								audience={audience}
								searchText={searchText}
								columns={columns}
								audienceDeleteInProgress={props.audienceDeleteInProgress}
								audienceSourceType={props.audienceSourceType}
								mode={props.mode}
							/>
						))}
					</tbody>
				</Table>
				<PageTurnOptions pageRange={pageRange} updatePageRange={handlePageChange} />
			</AudienceListTable>
		</>
	);

	function handleSearch(text: string) {
		const pRange = { ...pageRange, offset: 0 };
		setAudiences(text, pRange);
	}
	function setAudiences(text: string, pRange: IPageRange) {
		const filteredList = filterAudiences(text);
		pRange = { ...pRange, total: filteredList.length };
		const pagedList = getPagedAudiences(filteredList, pRange);
		setFilteredAudiences(filteredList);
		setPageRange({ ...pRange, total: filteredList.length });
		setSearchText(text);
		setPagedAudiences(pagedList);
	}
	function filterAudiences(text: string) {
		return props.audiences.filter((a) => {
			if (a.audienceName.toLowerCase().indexOf(text.toLowerCase()) !== -1) {
				return true;
			}
		});
	}
	function getPagedAudiences(audienceList: IAudience[], pRange: IPageRange) {
		return new PagingHelper<IAudience>().page(audienceList, pRange);
	}
	function handlePageChange(updatedPageRange: IPageRange) {
		setAudiences(searchText, updatedPageRange);
	}
	function handleColumnChange(columnChanges: string[]) {
		const copy = _cloneDeep(columns);
		const updatedColumns = ColumnHelper.UpdateSelectedColumns(copy, columnChanges);
		setColumns(updatedColumns);
	}
	function getFilteredCount() {
		return filteredAudiences.length;
	}
};
